<div :class="{toggle__button: true, 'active-only': activeOnly}">
    <template v-for="(item, key) in options" :key="key">
        <span
            :class="{toggle__label: true, active: modelValue === item.value, disabled}"
            v-on:click="updateValue(item.value)"
        >{{item.label}}</span>
    </template>
</div>
